import { useEffect } from 'react';

// The wicg-inert polyfill adds aria-hidden="true" when marking an element inert,
// but it does not remove aria-hidden when inert is removed.

export function useInert(trigger: boolean) {
  useEffect(() => {
    const elements = document.querySelectorAll<HTMLElement>(
      '[data-inert-if-modal]'
    );

    elements.forEach((el) => {
      if (trigger) {
        el.setAttribute('inert', '');
      } else {
        el.removeAttribute('inert');

        // Waiting until wicg-inert polyfill finishes its cycle,
        // without setTimeout, aria-hidden still exists
        setTimeout(() => {
          el.removeAttribute('aria-hidden');
        }, 0);
      }
    });
  }, [trigger]);
}
